<script setup lang="ts">
  interface NavBarProps {
    logoImage?: string
    logoImageDarkMode?: string
    tagline?: string
  }
  const { t } = useI18n()
  defineProps<NavBarProps>()

  const menuOpen = defineModel<boolean>('menu-open')

  function toggleMenu() {
    menuOpen.value = !menuOpen.value
  }
</script>
<template>
  <div data-testid="navbar" class="flex flex-row justify-between p-4 pl-6">
    <div data-testid="navbar__left" class="flex items-center">
      <router-link to="/" :aria-label="t('Navigate to homepage')">
        <slot name="left">
          <ImageDarkMode
            v-if="logoImage"
            :light-mode-image="logoImage"
            :dark-mode-image="logoImageDarkMode"
            :with-tagline="!!tagline"
          />
          <p
            v-if="tagline"
            class="text-[13px] font-normal text-content-secondary pl-2"
          >
            |&nbsp; {{ t(tagline) }}
          </p>
        </slot>
      </router-link>
    </div>
    <div data-testid="navbar__right" class="flex items-center">
      <slot name="right">
        <IconButton
          :icon="!menuOpen ? 'menu' : 'close'"
          classes="w-[24px] h-[24px]"
          class="p-8px lg:hidden"
          @click="toggleMenu"
        />
      </slot>
    </div>
  </div>
</template>
